var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.175,
    height: 62.175,
    viewBox: "0 0 62.175 62.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path459",
    d: "M0-682.665H62.175v62.175H0Z",
    transform: "translate(0 682.665)",
    fill: "#7b7bff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g453",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g455",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g457",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g463",
    transform: "translate(19.875 1.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path465",
    d: "M-283.354-54.206a29.736,29.736,0,0,0-17.18-5.432,29.789,29.789,0,0,0-11.213,2.176",
    transform: "translate(311.747 59.637)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g467",
    transform: "translate(54.719 14.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path469",
    d: "M0-348.714a29.743,29.743,0,0,0,6.241-18.277,29.734,29.734,0,0,0-5.077-16.666",
    transform: "translate(0 383.656)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g471",
    transform: "translate(1.214 12.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path473",
    d: "M-62.288,0a29.743,29.743,0,0,0-6.241,18.277A29.873,29.873,0,0,0-38.656,48.15a29.789,29.789,0,0,0,11.213-2.176",
    transform: "translate(68.529)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g475",
    transform: "translate(21.136 11.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path477",
    d: "M-99.316,0a9.963,9.963,0,0,0-9.952,9.952v3.355h4.976V9.952a4.982,4.982,0,0,1,4.976-4.976A4.982,4.982,0,0,1-94.34,9.952v3.355h4.976V9.952A9.963,9.963,0,0,0-99.316,0Z",
    transform: "translate(109.268)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g479",
    transform: "translate(27.652 29.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path481",
    d: "M-68.575-34.287a3.436,3.436,0,0,0-3.436-3.436,3.436,3.436,0,0,0-3.436,3.436,3.424,3.424,0,0,0,1.007,2.43v4.087a2.429,2.429,0,0,0,2.429,2.429,2.429,2.429,0,0,0,2.429-2.429v-4.087A3.425,3.425,0,0,0-68.575-34.287Z",
    transform: "translate(75.446 37.723)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g483",
    transform: "translate(18.458 24.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path485",
    d: "M-220.362,0h-18.9a3.178,3.178,0,0,0-3.178,3.178V19.167a3.178,3.178,0,0,0,3.178,3.178h18.9a3.178,3.178,0,0,0,3.178-3.178V3.178A3.178,3.178,0,0,0-220.362,0Z",
    transform: "translate(242.443)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g487",
    transform: "translate(6.344 6.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path489",
    d: "M-67.866-33.933a3.4,3.4,0,0,1-3.4,3.4,3.4,3.4,0,0,1-3.4-3.4,3.4,3.4,0,0,1,3.4-3.4A3.4,3.4,0,0,1-67.866-33.933Z",
    transform: "translate(74.666 37.333)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g491",
    transform: "translate(49.031 48.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path493",
    d: "M0-33.933a3.4,3.4,0,0,1,3.4-3.4,3.4,3.4,0,0,1,3.4,3.4,3.4,3.4,0,0,1-3.4,3.4A3.4,3.4,0,0,1,0-33.933Z",
    transform: "translate(0 37.333)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g495",
    transform: "translate(52.431 10.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path497",
    d: "M0,0H0",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.ebff586a4710b441aeac4071499697c8.svg";
export { ForwardRef as ReactComponent };